import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';
import CreateVideoModule from '../../modules/video/CreateVideoModule';

import Strings from '../../translations/Translations';

export default function CreateVideo() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('create_video')}
          subheading=""
          icon="pe-7s-music"
        />

        <Row>
          <Col sm={12}>
            <CreateVideoModule
            />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
